import React, { useMemo } from "react"
import 'swiper/css';
import 'swiper/css/pagination';
import { CollaborationPost } from "../../../../types/collaborations/CollaborationTypes";
import Badge from "../../../badges/Badge";
import { formatNumber, toValidNumber } from "../../../../utils/helpers";
import IGPostIcon from "../../../icons/IGPostIcon";
import IGStoryIcon from "../../../icons/IGStoryIcon";
import ReelsIcon from "../../../icons/ReelsIcon";
import { AppDispatch, RootState } from "../../../../redux-stores/store";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPost, setSelectedSocialPost } from "../../../../redux-stores/slices/layoutSlice";
import InstagramCaption from "../../../InstagramCaption";
import CollapsableContent from "../../../CollapsableContent";
import { useParams } from "react-router-dom";

const CollaborationContent: React.FC<{ collaborationPosts: CollaborationPost[] }> = ({ collaborationPosts }) => {

    const dispatch: AppDispatch = useDispatch();
    const {campaignId} = useParams();
    const collaboration = useSelector((state: RootState) => state.collaborationDetails.collaborations[campaignId!]?.collaborationData);
    const socialAccount = collaboration?.collaboration?.social_account;

    const reels = useMemo(() => {
        return collaborationPosts.filter((cp) => cp.social_post.type === "REELS");
    }, [collaborationPosts])

    const posts = useMemo(() => {
        return collaborationPosts.filter((cp) => cp.social_post.type === "FEED");
    }, [collaborationPosts])

    const stories = useMemo(() => {
        return collaborationPosts.filter((cp) => cp.social_post.type === "STORY");
    }, [collaborationPosts])

    const videos = useMemo(() => {
        return collaborationPosts.filter((cp) => cp.social_post.type === "VIDEO");
    }, [collaborationPosts])


    return (
        <div>
            {
                ['Reels', 'Posts', 'Stories', 'Videos'].map((contentType, i) => {
                    if(contentType === 'Posts' && posts.length === 0) return null;
                    if(contentType === 'Stories' && stories.length === 0) return null;
                    if(contentType === 'Videos' && videos.length === 0) return null;
                    if(contentType === 'Reels' && reels.length === 0) return null;
                    return (
                        <div key={i} className="specification-card">
                            <h6>{contentType}</h6>
                            {
                                (contentType === 'Reels' ? reels : (contentType === 'Posts' ? posts : (contentType === 'Stories' ? stories : (contentType === 'Videos' ? videos : [])))).length > 0 &&
                                <React.Fragment>
                                    {
                                        (contentType === 'Reels' ? reels : (contentType === 'Posts' ? posts : (contentType === 'Stories' ? stories : (contentType === 'Videos' ? videos : [])))).map((post, i) => {
                                            return (
                                                <div key={i} className="card-body d-flex mt-2 flex-row">
                                                    <div onClick={() => dispatch(setSelectedSocialPost({socialAccountId: socialAccount?.uuid, socialPostId: post.social_post.uuid}))} className="position-relative milestone-post-thumbnail" style={{ backgroundImage: `url(${post.social_post.thumbnail_url})` }}>
                                                        {
                                                            post.status === 'approved' && <span className="post-status-badge approved"> <Badge size="xs" variant='success'><i className="fa fa-check me-1"></i>Approved</Badge></span>
                                                        }
                                                        {
                                                            post.status === 'pending' && <span className="post-status-badge new"><Badge size="xs" variant="warning"><i className="fas fa-clock me-1"></i> Pending Approval</Badge></span>
                                                        }
                                                        {
                                                            post.status === 'rejected' && <span className="post-status-badge declined"> <Badge size="xs" variant="danger"><i className="fa fa-times me-1"></i> Declined</Badge> </span>
                                                        }
                                                        {
                                                            post.social_post?.ig?.media_product_type === 'REELS' &&
                                                            <span className="media-type-icon">
                                                                <ReelsIcon color="#FFFFFF" />
                                                            </span>
                                                        }
                                                        {
                                                            post.social_post?.ig?.media_product_type === 'STORY' &&
                                                            <span className="media-type-icon">
                                                                <IGStoryIcon />
                                                            </span>
                                                        }
                                                        {
                                                            post.social_post?.ig?.media_product_type === 'VIDEO' &&
                                                            <span className="media-type-icon">
                                                                <i className="fab fa-youtube"></i>
                                                            </span>
                                                        }
                                                        {
                                                            !["REELS", "STORY", "VIDEO"].includes(post.social_post?.ig?.media_product_type!) &&
                                                            <span className="media-type-icon">
                                                                <IGPostIcon />
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="d-flex flex-fill flex-column justify-content-between align-items-between ms-3" style={{minHeight: '200px'}}>
                                                        <div>

                                                        {
                                                            post.social_post?.platform === 'ig' && post.social_post?.ig?.caption &&
                                                            <CollapsableContent>
                                                                <InstagramCaption text={post.social_post?.ig?.caption} />
                                                            </CollapsableContent>
                                                        }
                                                        {
                                                            post.social_post?.platform === 'yt' && post.social_post?.yt?.title &&
                                                            <div className="mb-2">
                                                                <strong>{post.social_post?.yt?.title}</strong>
                                                            </div>
                                                        }
                                                        </div>

                                                        <div className="d-flex justify-content-between">
                                                            <span><i className="fa-solid fa-heart"></i> {formatNumber(toValidNumber(post.social_post.like_count))}</span>
                                                            <span><i className="fa-solid fa-comment"></i>  {formatNumber(toValidNumber(post.social_post.comments_count))}</span>
                                                            <span><i className="fa-solid fa-eye"></i> {formatNumber(toValidNumber(post.social_post.views_count))}</span>
                                                            {/* <span><i className="fa-solid fa-share-nodes"></i>  {formatNumber(toValidNumber(post.social_post.shares_count))}</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </React.Fragment>
                            }
                            {
                                (contentType === 'Reels' ? reels : (contentType === 'Posts' ? posts : (contentType === 'Stories' ? stories : (contentType === 'Videos' ? videos : [])))).length === 0 && <span className="w-100 d-flex justify-content-center p-4">No Content Posted</span>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default CollaborationContent